// Every careers URL in the app is built here. /careers is the public
// address; the old /job-view and /job-apply links redirect to it, so links
// shared before keep working.
export const CAREERS_BASE = "/careers";

export const careersPath = (slug, ...rest) =>
  [CAREERS_BASE, slug && encodeURIComponent(slug), ...rest].filter(Boolean).join("/");
